import { Alert, AlertTitle, Box, Button, FormControlLabel, Switch, TextField, Typography, alpha, useTheme } from "@mui/material";
import { IMarketplace } from "../../../../interfaces/IMarketplace"
import { useMarketplaces } from "../../../../hooks/useMarketplaces";
import { useState } from "react";
import { Edit, Save, StorefrontOutlined } from "@mui/icons-material";
import { SecaoConfiguracao } from "../../../../../core/components/SecaoConfiguracao";

interface StatusMarketplaceProps {
    marketplace: IMarketplace
}

export const StatusMarketplacePaper = ({ marketplace }: StatusMarketplaceProps) => {
    const { salvar, loading } = useMarketplaces();
    const theme = useTheme();

    const [edicaoHabilitada, setEdicaoHabilitada] = useState(false);
    const [mensagem, setMensagem] = useState<string | undefined>(marketplace.configuracao?.status?.mensagem);
    const [aberto, setAberto] = useState<boolean>(marketplace.configuracao?.status?.aberto ?? false);
    const handleEdicaoHabilitada = async () => {
        if (!edicaoHabilitada) {
            return setEdicaoHabilitada(true);
        }

        await salvar({
            ...marketplace,
            configuracao: {
                ...marketplace.configuracao,
                status: {
                    aberto,
                    mensagem,
                    dataHoraUltimaAtualizacao: new Date()
                }
            }
        })
        setEdicaoHabilitada(false);
    }

    const corStatus = aberto ? theme.palette.success.main : theme.palette.error.main;

    return (
        <SecaoConfiguracao
            titulo="Status"
            descricao="Disponibilidade do cardápio para novos pedidos"
            icone={<StorefrontOutlined />}
            corIcone={corStatus}
            acoes={
                <Button
                    variant={edicaoHabilitada ? "contained" : "outlined"}
                    size="small"
                    onClick={handleEdicaoHabilitada}
                    endIcon={edicaoHabilitada ? <Save /> : <Edit />}
                >
                    {edicaoHabilitada ? "Salvar" : "Editar"}
                </Button>
            }
        >
            <form>
                <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 1,
                            p: 1.5,
                            borderRadius: "12px",
                            border: `1px solid ${alpha(corStatus, 0.35)}`,
                            backgroundColor: alpha(corStatus, 0.08)
                        }}
                    >
                        <Box>
                            <Typography variant="body2" fontWeight={600} color={corStatus}>
                                {aberto ? "Marketplace aberto" : "Marketplace fechado"}
                            </Typography>
                            <Typography variant="caption" color="text.secondary">
                                {aberto
                                    ? "Disponível para receber novos pedidos"
                                    : "Indisponível para receber novos pedidos"
                                }
                            </Typography>
                        </Box>
                        <FormControlLabel
                            sx={{ mr: 0 }}
                            control={<Switch checked={aberto} />}
                            label=""
                            value={aberto}
                            onChange={(e, v) => setAberto(v)}
                            disabled={!edicaoHabilitada}
                        />
                    </Box>
                    <TextField
                        label="Mensagem exibida ao cliente"
                        value={mensagem ?? ""}
                        size="small"
                        fullWidth
                        placeholder="Ex.: voltamos amanhã às 18h"
                        onChange={(e) => setMensagem(e.target.value)}
                        disabled={!edicaoHabilitada}
                        InputLabelProps={{ shrink: true }}
                    />
                    {!edicaoHabilitada && (
                        <Alert severity="info" variant="outlined" sx={{ borderRadius: "12px" }}>
                            <AlertTitle sx={{ fontSize: "0.8125rem", mb: 0 }}>Abertura manual</AlertTitle>
                            <Typography variant="caption">
                                Os horários cadastrados são apenas informativos: a abertura e o fechamento
                                do cardápio são controlados por aqui.
                            </Typography>
                        </Alert>
                    )}
                </Box>
            </form>
        </SecaoConfiguracao>
    );
}
